export enum ETextAlign {
  Left = 'left',
  Right = 'right',
  Center = 'center',
}
